module.exports = __webpack_public_path__ + "static/media/close.1257f21e.svg";